import { toast } from 'react-toastify';

interface CopyToClipboardOptions {
  text: string;
  successMessage?: string;
  errorMessage?: string;
}

export async function copyToClipboard({
  text,
  successMessage = 'Copiado al portapapeles',
  errorMessage = 'Error al copiar al portapapeles',
}: CopyToClipboardOptions): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      toast.success(successMessage);
      return true;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    if (success) {
      toast.success(successMessage);
    } else {
      toast.error(errorMessage);
    }
    return success;
  } catch {
    toast.error(errorMessage);
    return false;
  }
}
